import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_CTA_AVO_STORIES} from "../../utils/input-field-list-static-page";
import {setAvoStoriesCtaDetail, setAvoStoriesErrorMessage} from "../../reducers/avo-stories.reducer";
import FormGeneralComponent from "../../components/static-page/form-general.component";
import React, {useEffect} from "react";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";

const Cta = () => {
    const dispatch = useDispatch()
    const {ctaDetail, avoStoriesErrorMessage} = useSelector(state => state.avoStoriesReducer)
    const {fetching: getCTA} = useFetch(API.AVO_STORIES_GET_CTA)
    const {fetching: updateCTA, isLoading} = useFetch(API.AVO_STORIES_UPDATE_CTA)
    let fieldList = FIELD_LIST_CTA_AVO_STORIES
    let showCta = {
        label: 'CTA',
        key: 'show_cta',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoStoriesCtaDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateCTA(ctaDetail).then(response => {
            dispatch(setAvoStoriesErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('CTA Updated'))
            dispatch(setAvoStoriesCtaDetail(response?.data))
        }).catch(err => {
            dispatch(setAvoStoriesErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getCTA().then(response => {
            dispatch(setAvoStoriesCtaDetail(response?.data))
        })

        return () => {
            dispatch(setAvoStoriesErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={ctaDetail}
            switchToggleField={showCta}
            fieldList={fieldList}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={avoStoriesErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default Cta